export const KEY_POST_QUIZ_START = 'post.quiz-start.call';
export const KEY_POST_QUIZ_BY_ID_NEXT = 'post.quiz-by-id-next.call';
export const KEY_GET_QUIZ_BY_ID_RESULT = 'get.quiz-by-id-result.call';
export const KEY_GET_QUIZ_BY_ID = 'get.quiz-by-id.call';
